import clsx from 'clsx';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { SubscriptionContext } from '@/modules/payment/subscription/context/context';
import { subscriptionActionsTypes } from '@/modules/payment/subscription/context/reducer';
import { IPayment } from '@/modules/payment/types';
const PlanTabs: React.FC = () => {
  const { t } = useTranslation('payment');
  const {
    state: { intervalType },
    dispatch,
  } = useContext(SubscriptionContext);

  const handleChangingIntervalType = (interval: IPayment.IIntervalTypes) => {
    dispatch({
      type: subscriptionActionsTypes.setIntervalType,
      payload: interval,
    });
  };

  return (
    <div className='mb-24 flex flex-col gap-2'>
      <div className='flex w-full items-center justify-center'>
        <div
          className={clsx(
            'cursor-pointer rounded-tl-lg rounded-bl-lg border-xs px-32 py-9 text-14 font-semi-bold capitalize',
            intervalType === 'month'
              ? 'border-primary-default bg-primary-default text-white'
              : 'border-neutralVariant-80 bg-background-transparent text-text-default'
          )}
          onClick={() => handleChangingIntervalType('month')}
        >
          {t('monthly')}
        </div>
        <div
          className={clsx(
            'cursor-pointer rounded-tr-lg rounded-br-lg border-xs px-32 py-9 text-14 font-semi-bold capitalize',
            intervalType === 'year'
              ? 'border-primary-default bg-primary-default text-white'
              : 'border-neutralVariant-80 bg-background-transparent text-text-default'
          )}
          onClick={() => handleChangingIntervalType('year')}
        >
          {t('yearly')}
        </div>
        <div
          className={clsx(
            'relative mx-2 rounded-lg bg-secondary-20 py-2 px-12 text-12 text-white',
            'after:absolute after:top-1/2 after:-left-2 after:h-0 after:w-0 after:-translate-y-1/2 after:rotate-[270deg] after:border-x-lg after:border-b-xl after:border-x-background-transparent after:border-b-secondary-20'
          )}
        >
          {t('best-value')}
        </div>
      </div>
      <div className='text-center text-base text-text-default'>
        {t('pick-plan')}
      </div>
    </div>
  );
};

export { PlanTabs };
